import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import Location from "../../components/Admin/Location"

const Loc = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Locations | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <Location />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Loc
